<template>
    <v-toolbar class="main-toolbar" dense flat>
        <v-toolbar-title>
            <v-btn class="back-dashboard" exact active-class="no-display" :to="{name: 'dashboardHome'}" text><v-icon>mdi-arrow-left</v-icon> {{ $vuetify.lang.t('$vuetify.return_homepage') }}</v-btn>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <!--<v-btn class="success text-truncate">
            You have 12 new leads
            <v-icon>mdi-magnify</v-icon>
        </v-btn>-->
        <div class="right-btn-group">
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="text-truncate" v-bind="attrs" v-on="on">
                    <v-avatar size="32px" style="margin:0 10px;">
                        <img
                        :alt="user"
                        v-if="userdata.agent.picture_url"
                        :src="$baseURL + 'uploads/'+ userdata.agent.picture_url"
                        >
                        <img
                        :alt="user"
                        v-else
                        :src="profile_picture_standard"
                        >
                    </v-avatar>
                    <span
                        class="d-inline-block text-truncate text-capitalize"
                    >
                        {{user}}
                    </span>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    @click="setRedirect(item.href)"
                    >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn>
            <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
        </div>
        </v-toolbar>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode"
import profile_picture from '../../../assets/profile_picture.png'
export default {
    name: "headerSidebarComponent",
    data: () => ({
        items: [
            { title: 'Mon Compte', href: 'account'},
            { title: 'Déconnexion', href: 'logout'}
        ],
        email: '',
        profile_picture_standard: profile_picture,
        user: '',
        userdata: {}
    }),
    async created() {

        this.email = VueJwtDecode.decode(this.$store.getters.getUser).userData.email
        this.user = VueJwtDecode.decode(this.$store.getters.getUser).userData.username
        this.userdata = Object.assign(VueJwtDecode.decode(this.$store.getters.getUser).userData, {agent: {}})
            if(this.userdata.agent_id > 0){
                await this.axios
                    .get('/agent/listing')
                    .then(res =>
                    {
                        let agentList = res.data
                        this.userdata.agent = agentList.filter(v => { return v.id === this.userdata.agent_id } )[0]
                    })
            }
    },
    methods: {
        logout() {
            console.log('logout')
            this.$store.dispatch('logout');
            this.$router.push({name: 'dashboardLogin'})
        },
        setRedirect(data){
            if(data === 'logout'){
                this.logout()
            }else{
                this.$router.push({name: 'myProfile'})
            }
        }

    }

}
</script>

<style lang="scss" scoped>

.no-display {
    display:none;
}
.main-toolbar {
    background: transparent !important;
    margin-right: 16px;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/commons/header_sidebar.component.vue